import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromEmployee from '../_reducers/employee';

export const selectEmployeeState = createFeatureSelector<fromEmployee.EmployeeState>('employees');

export const selectAllEmployees = createSelector(selectEmployeeState, fromEmployee.selectAll);

export const selectEmployeeEntities = createSelector(
  selectEmployeeState,
  fromEmployee.selectEntities
);

export const selectEmployeeById = (id: number) =>
  createSelector(selectEmployeeEntities, (entities) => entities[id]);

export const selectEmployeeTotal = createSelector(selectEmployeeState, fromEmployee.selectTotal);
